"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCATION_TYPES = exports.LOCATIONS_DROPDOWN_MAX_HEIGHT = exports.COVID_VACCINE_PROVIDER_TYPE = exports.PROVIDER_TYPE = exports.LOCATION_ENTITY_TYPE = exports.ENTITY_TYPE = void 0;
exports.ENTITY_TYPE = 'entity_type';
exports.LOCATION_ENTITY_TYPE = 'location';
exports.PROVIDER_TYPE = 'provider_type';
exports.COVID_VACCINE_PROVIDER_TYPE = 'Vaccine Clinic - COVID-19';
/**
 * Maximum height for the dropdown in provider location
 */
exports.LOCATIONS_DROPDOWN_MAX_HEIGHT = 327;
/**
 * ENUM for defining the location types
 */
exports.LOCATION_TYPES = {
    BOOKABLE: 'BOOKABLE',
    NON_BOOKABLE: 'NON_BOOKABLE'
};
//# sourceMappingURL=provider.js.map